import React from 'react';

const ArtistContentMainLink = (props:any) => {
const link = props.artistLink;

return (
    <div className={'font-bold'}>
        <a className={'no-underline text-black cursor-pointer'} href={link}>Explore {'>'}</a>
    </div>
)
}

export default ArtistContentMainLink;